<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-3 p-3">
    <div class="flex items-center rounded-md bg-gray-100 p-3">
      <p class="mr-3 mb-0 text-gray-700">
        <b>{{ t("targetings-modal.asin_level_isolation") }}</b
        >: {{ t("targetings-modal.isolation_definition") }}
      </p>

      <IToggle
        [checked]="asinIsolation()"
        [disabled]="!!modalData.isReadOnly"
        [loading]="isUpdatingAsinIsolation()"
        (checkedChange)="updateIsolation(!!$event)"
      />
    </div>
    <div class="flex min-h-0 flex-1 flex-col divide-y rounded-md border pt-3">
      @if (
        targetingType() === StrategyTargetingType.KEYWORDS || modalData.strategy.strategyType === StrategyType.BRAND
      ) {
        <div class="flex flex-1 flex-col">
          <div class="flex items-center justify-between gap-x-3 p-3 pt-0">
            <div class="flex items-center">
              <span class="font-medium text-gray-800">{{ t("targetings-modal.keyword_targetings") }}</span>
              <IBadge [label]="shownKeywords().length.toString()" color="gray" class="ml-2 select-none" />
              @if (modalData.strategy.strategyType !== StrategyType.BRAND) {
                <button
                  iButton
                  variant="secondary"
                  size="xs"
                  class="ml-2"
                  [iTooltip]="t('targetings-modal.update_this_strategy_to_product_targeting')"
                  [disabled]="!!modalData.isReadOnly"
                  (click)="toggleTargetingType()"
                >
                  {{ t("targetings-modal.change_to_product") }}
                </button>
              }
            </div>
            <button iButton variant="ghost" size="icon-sm" (click)="editKeywordTargetings()">
              <IIcon name="edit" />
            </button>
          </div>
          <div class="mx-1 mb-1 flex items-center border-b" iInputGroup>
            <IIcon name="search" iInputGroupPrefix />
            <input
              iInputGroupInput
              [(ngModel)]="searchKeywordQuery"
              placeholder="{{ t('targetings-modal.search_keywords') }}"
              autocomplete="off"
              autoFocus
            />
          </div>

          <div class="flex flex-auto basis-0 flex-col divide-y divide-gray-100 overflow-auto">
            @for (targeting of shownKeywords(); track targeting.targetingValue) {
              <div class="flex w-full items-center justify-between px-3 py-2">
                <span class="text-sm text-gray-800">{{ targeting.targetingValue }}</span>
                <IBadge
                  [label]="targeting.matchType"
                  [color]="targeting.matchType === MatchType.exact ? 'green' : 'black'"
                  variant="soft"
                  class="ml-2"
                />
              </div>
            } @empty {
              <p class="pt-4 text-center text-sm text-gray-500">
                @if (searchKeywordQuery()) {
                  {{ t("targetings-modal.no_result", [searchKeywordQuery()]) }}
                } @else {
                  {{ t("targetings-modal.no_keywords") }}
                }
              </p>
            }
          </div>
        </div>
      }
      @if (
        targetingType() === StrategyTargetingType.PRODUCTS || modalData.strategy.strategyType === StrategyType.BRAND
      ) {
        <div class="flex flex-1 flex-col">
          <div
            class="flex items-center justify-between gap-x-3 p-3"
            [ngClass]="{ 'pt-0': modalData.strategy.strategyType !== StrategyType.BRAND }"
          >
            <div class="flex items-center">
              <span class="text-gray-8000 font-medium">{{ t("targetings-modal.product_targetings") }}</span>
              <IBadge [label]="shownProducts().length.toString()" color="gray" class="ml-2 select-none" />
              @if (modalData.strategy.strategyType !== StrategyType.BRAND) {
                <button
                  iButton
                  variant="secondary"
                  size="xs"
                  class="ml-2"
                  [iTooltip]="t('targetings-modal.update_this_strategy_to_keyword_targeting')"
                  [disabled]="!!modalData.isReadOnly"
                  (click)="toggleTargetingType()"
                >
                  {{ t("targetings-modal.change_to_keyword") }}
                </button>
              }
            </div>
            <button iButton variant="ghost" size="icon-sm" (click)="editProductTargetings()">
              <IIcon name="edit" />
            </button>
          </div>
          <div class="mx-1 mb-1 flex items-center border-b" iInputGroup>
            <IIcon name="search" iInputGroupPrefix />
            <input
              iInputGroupInput
              [(ngModel)]="searchProductQuery"
              placeholder="{{ t('targetings-modal.search_products') }}"
              autocomplete="off"
              autoFocus
            />
          </div>

          <div class="flex flex-auto basis-0 flex-col divide-y divide-gray-100 overflow-auto">
            @for (targeting of shownProducts(); track targeting.targetingValue) {
              <app-asin-item
                [asin]="targeting.targetingValue"
                [isReadOnly]="true"
                [marketplace]="modalData.accountMarketplace.marketplace"
                [actionsButtons]="true"
              />
            } @empty {
              <p class="pt-4 text-center text-sm text-gray-500">
                @if (searchProductQuery()) {
                  {{ t("targetings-modal.no_result", [searchProductQuery()]) }}
                } @else {
                  {{ t("targetings-modal.no_products") }}
                }
              </p>
            }
          </div>
        </div>
      }
    </div>
    <div class="flex shrink-0 justify-end gap-x-2">
      <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.close") }}</button>
    </div>
  </div>

  <ng-template #productTargetingsModal>
    <div class="flex h-full flex-col gap-4">
      <app-asin-selection
        class="min-h-0 flex-1"
        [allowOtherCatalog]="modalData.strategy.strategyType !== StrategyType.BRAND"
        [asinsLimit]="this.MAX_STRATEGY_ASINS"
        [selectedAsins]="this.productTargetings()"
        [readonly]="!!modalData.isReadOnly"
        (selectedAsinsChange)="newProductTargetings.set($event)"
      />
      <div class="flex justify-end gap-x-2">
        <button iButton variant="secondary" size="md" (click)="advertisedProductsModalRef?.close()">
          {{ t("common.close") }}
        </button>
        <button
          iButton
          size="md"
          [disabled]="!!modalData.isReadOnly"
          (click)="updateProductTargetings(newProductTargetings())"
        >
          {{ t("common.save") }}
        </button>
      </div>
    </div>
  </ng-template>
</ng-container>
